import { AudioRecordingModelData } from "@/store/audio-recordings";
import { AudioRecordingProcessingStatus } from "@/store/audio-recordings/types";
import {
  BaseAudioRecordingAppEventOperation,
  BaseAudioRecordingAppEventOperationParams,
} from "./BaseAudioRecordingAppEventOperation";

export class MarkStartedProcessingAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind() {
    return "MARK_STARTED_PROCESSING_AUDIO_RECORDING" as const;
  }

  constructor(params: BaseAudioRecordingAppEventOperationParams) {
    super(params);
  }

  protected getModelDataUpdates(
    _existingData: AudioRecordingModelData
  ): Partial<AudioRecordingModelData> {
    return {
      processing_status: AudioRecordingProcessingStatus.IN_PROGRESS,
    };
  }
}
